import { COMPANY } from "@/data";
import { Reveal } from "@/components/motion";

function LegalHero({ title }) {
  return (
    <section className="relative bg-ink text-white grain pt-40 pb-16 md:pt-48">
      <div className="relative z-10 mx-auto max-w-4xl px-5 md:px-8">
        <Reveal>
          <span className="overline text-xs uppercase tracking-[0.3em] text-gold font-medium">Rechtliches</span>
          <h1 className="mt-4 font-serif text-5xl md:text-6xl tracking-tight">{title}</h1>
        </Reveal>
      </div>
    </section>
  );
}

const Section = ({ title, children }) => (
  <div>
    <h2 className="font-serif text-2xl text-ink mb-3">{title}</h2>
    <div className="leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Datenschutz() {
  return (
    <main data-testid="datenschutz-page">
      <LegalHero title="Datenschutzerklärung" />
      <section className="bg-cream py-20 md:py-24">
        <div className="mx-auto max-w-4xl px-5 md:px-8 space-y-10 text-neutral-700">
          <Section title="1. Verantwortlicher">
            <p>
              Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der DSGVO ist:<br />
              {COMPANY.legalName}, Inhaber: {COMPANY.owners}<br />
              {COMPANY.address}<br />
              Telefon: {COMPANY.phone} · E-Mail: {COMPANY.email}
            </p>
          </Section>

          <Section title="2. Erhebung und Verarbeitung personenbezogener Daten">
            <p>
              Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer funktionsfähigen Website
              sowie unserer Inhalte und Leistungen erforderlich ist. Wenn Sie unser Kontaktformular nutzen, erheben wir
              die von Ihnen angegebenen Daten (Name, Telefonnummer, E-Mail-Adresse, gewünschte Leistung sowie Ihre Nachricht),
              um Ihre Anfrage zu bearbeiten.
            </p>
          </Section>

          <Section title="3. Rechtsgrundlage">
            <p>
              Die Verarbeitung der über das Kontaktformular übermittelten Daten erfolgt auf Grundlage von
              Art. 6 Abs. 1 lit. b DSGVO (Anbahnung bzw. Erfüllung eines Vertrags) sowie Art. 6 Abs. 1 lit. f DSGVO
              (berechtigtes Interesse an der Bearbeitung Ihrer Anfrage).
            </p>
          </Section>

          <Section title="4. Speicherdauer">
            <p>
              Ihre Daten werden gelöscht, sobald sie für die Erreichung des Zwecks ihrer Erhebung nicht mehr erforderlich sind
              und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
            </p>
          </Section>

          <Section title="5. Cookies">
            <p>
              Diese Website verwendet ausschließlich technisch notwendige Cookies, die für den Betrieb der Seite erforderlich sind.
              Es werden keine Tracking- oder Marketing-Cookies eingesetzt.
            </p>
          </Section>

          <Section title="6. Weitergabe von Daten">
            <p>
              Eine Übermittlung Ihrer persönlichen Daten an Dritte findet nur statt, soweit dies zur Bearbeitung Ihrer Anfrage
              erforderlich ist (z. B. an unseren E-Mail-Dienstleister zum Versand der Kontaktanfrage). Ein Verkauf Ihrer Daten erfolgt nicht.
            </p>
          </Section>

          <Section title="7. Ihre Rechte">
            <p>
              Sie haben jederzeit das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16), Löschung (Art. 17),
              Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch (Art. 21).
              Zudem steht Ihnen ein Beschwerderecht bei einer Aufsichtsbehörde zu.
            </p>
          </Section>

          <Section title="8. Kontakt bei Datenschutzfragen">
            <p>
              Bei Fragen zum Datenschutz erreichen Sie uns unter: {COMPANY.email} oder telefonisch unter {COMPANY.phone}.
            </p>
          </Section>
        </div>
      </section>
    </main>
  );
}
